import React, { useEffect, useState, useRef } from "react"
import moment from "moment"
import { Popover } from "@mui/material"
import Button from "../../../Button"
import "./PatientChip.scss"
import { useSelector } from "react-redux"
import AppointmentCalendarUtils from "../../AppointmentCalenderUtils"
import {
  MocUserRole,
} from "../../../../core/services/models/Enums"
import {
  addInvoiceLink,
  getCenterDetail,
  getSmartSummaryData,
  markAppointmentReadyForDischarge,
} from "../../../../core/services/api"
import Toast from "components/Toast"
import InputField from "components/InputField"
import { useHistory } from "react-router"
import { bookbedbyId } from "core/services/api/bedManagementService"
import debounce from 'lodash/debounce'
import { calculateAge } from "core/utils/date"
import { isAfter, subDays } from "date-fns"

export default function PatientChip({
  patient,
  onButtonClick,
  disableClick = false,
  disablePopup,
  outline = false,
  height = 1,
  description = null,
  userRole,
  slotDuration = 15,
  bedSlotDuration,
  showModal,
  reloadAppointments
}: any) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null)
  const open = Boolean(anchorEl)
  const id = open ? "patient-detail-popover" : undefined
  const [displayToast, toggleDisplayToast] = useState<any>()
  const [show, setshow] = useState<any>()
  const [source, setSource] = useState<string>("")
  const [opens, setOpen] = useState<any>(false)
  const [reasons, setReason] = useState<any>()
  const [payment, setIsPayment] = useState<any>()
  const [sendpaymentLink, setSendPaymentLink] = useState<any>()
  const history = useHistory()
  const [centerSlots, setCenterSlots] = useState<any>("")
  const [centerBedSlots, setCenterBedSlots] = useState<any>()
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const timeoutRef = useRef<any>(null);
  const [showDueDetails, setShowDueDetails] = useState<boolean>(false);
  const [disableButton, setDisableButton] = useState<boolean>(false);

  useEffect(() => {
    let centerDetails = userDetail?.currentCenter?.centerId
    if (open) {
      if (!centerSlots || !centerBedSlots) {
        getCenterDetail(centerDetails).then((res) => {
          setCenterSlots(res?.slotDuration)
          setCenterBedSlots(res?.bedSlotDuration)
        })
      }
    }
  }, [open])


  useEffect(() => {
    if (showModal) {
      handleClose()
    }
  }, [showModal])




  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    //fetch smart summary
    fetchSmartSummary()
    setshow(false)
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const [colorCode, setColorCode] = useState<any>()
  const isConsultantsViewShown = useSelector(
    (state: any) => state.drawer?.isConsultantsViewShown
  )
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const [patientName, setPatientName] = useState()

  const [slots, updateSlots] = useState([])

  const [NurseSlots, updateNurseSlots] = useState([])

  const [smartSummary, updateSmartSummary] = useState<any>()
  const [bedBook, setbedBook] = useState<any>()
  const [pending, setPending] = useState<any>(false)

  function fetchSmartSummary() {
    getSmartSummaryData(patient?.patientId)
      .then((res) => {
        updateSmartSummary(res?.data)
      })
      .catch((err) => {
        console.log("smart summary fetch for a patient fail", err)
      })
  }

  // useEffect(() => {
  //   if (patient?.bedIsVacant !== true) {
  //     setBedVacant(true)
  //   }
  // }, [patient])

  function handleBedVacant() {
    let tempBody: any = {}
    tempBody["bedId"] = patient?.bedId
    tempBody["roomId"] = patient?.roomId
    tempBody["bedBookingStatus"] = "BOOKED"
    tempBody["bedIsVacant"] = true
    tempBody["bookedSlots"] = patient?.bookedSlots

    // setIsLoading(true)

    bookbedbyId(patient?.id, tempBody)
      .then((res: any) => {
        setbedBook(res)
        setIsLoading(false)
        toggleDisplayToast({
          text: "The bed has been Marked Vacant successfully",
          type: "success",
        })
      })
      .catch((err: any) => {
        setIsLoading(false)
        toggleDisplayToast({
          text: `${err?.response?.data?.message}`,
          type: "error",
        })
      })
  }

  const handleReadyForDischarge = () => {
    markAppointmentReadyForDischarge(patient?.appointmentId)
      .then((res: any) => {
        setIsLoading(false)
        toggleDisplayToast({
          text: "Discharge notification sent to Front Desk and RMO",
          type: "success",
        })
      })
      .catch((err: any) => {
        setIsLoading(false)
        toggleDisplayToast({
          text: `${err?.response?.data?.message}`,
          type: "error",
        })
      })
  }

  // useEffect(() => {
  //   setbedBook(patient?.bedIsVacant === true)
  // }, [patient])

  useEffect(() => {
    if (patient) {
      setPatientName(
        userRole !== MocUserRole.PATIENT
          ? (patient?.isVIP || patient?.patientIsVip)
            ? (patient?.mocId ? patient?.mocId : patient?.patientMocId)
            : patient?.patientName
          : patient?.patientName
      )
      //updateSlots

      updateSlots(
        patient?.appointmentType === "IPD" &&
          patient?.allottedBed?.slots?.length > 0
          ? patient?.allottedBed?.slots
          : patient?.slots
      )
    }
  }, [patient])

  useEffect(() => {
    userRole === MocUserRole.NURSE &&
      updateNurseSlots(patient?.bookedSlots ? patient?.bookedSlots : "")
  }, [patient])



  useEffect(() => {
    if (isConsultantsViewShown !== null) {
      if (isConsultantsViewShown || patient?.appointmentType === "IPD" || userRole === MocUserRole.NURSE) {
        setColorCode(
          patient?.consultantColourCode
            ? patient?.consultantColourCode
            : patient?.consultantColorCode ?
              patient?.consultantColorCode
              : "#f86a7c"
        )
      } else {
        setColorCode(
          patient?.centerColorCode ? patient?.centerColorCode : "#f86a7c"
        )
      }
    }
  }, [isConsultantsViewShown])

  function hexToRgb(hex: any, opacity: any) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    if (result) {
      var r = parseInt(result[1], 16)
      var g = parseInt(result[2], 16)
      var b = parseInt(result[3], 16)
      return `rgba(${r},${g},${b},${opacity})`
    }
    return null
  }

  function renderHorizontalStepper() {
    return (
      <div className="col-md-12 col-lg-12 d-flex stepper-wrapper">
        <div className="divider-line col-9" />
        <div className="checked-in pointer">
          <div
            className="text-center cursor-pointer"
            onClick={() => {
              if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
              }
              timeoutRef.current = setTimeout(() => {
                if (patient?.status === "BOOKED") {
                  onButtonClick({
                    source: "checkIn",
                    patient: patient,
                  });
                }
              }, 100);
            }
            }
          >
            <img
              className={`stepper-icon ${patient?.arrivalTime ? "completed-filler" : ""
                }`}
              alt="stepper icon"
              src="../../assets/images/stepperIcon.svg"
            />
          </div>
          <div className="title">
            {patient?.arrivalTime ? "Checked in" : "Check in"}
          </div>
          {patient?.arrivalTime && (
            <div className="time">
              {moment(patient?.arrivalTime, "HH:mm").format("hh:mm A")}
            </div>
          )}
        </div>
        <div className="consultation pointer">
          <div
            className="text-center cursor-pointer"
            onClick={() =>
              patient?.status === "ARRIVED"
                ? onButtonClick({
                  source: "consultation",
                  patient: patient,
                })
                : null
            }
          >
            <img
              className={`stepper-icon ${patient?.engageTime ? "completed-filler" : ""
                }`}
              alt="stepper icon"
              src="../../assets/images/stepperIcon.svg"
            />
          </div>
          <div className="title">
            {patient?.engageTime ? "In Consultation" : "Consultation"}
          </div>
          {patient?.engageTime && (
            <div className="time">
              {moment(patient?.engageTime, "HH:mm").format("hh:mm A")}
            </div>
          )}
        </div>

        <div className="checked-out pointer">
          <div
            className="text-center cursor-pointer"
            onClick={() =>
              patient?.engageTime !== null
                ? onButtonClick({ source: "checkOut", patient: patient })
                : null
            }
          >
            <img
              className={`stepper-icon ${patient?.status !== "COMPLETED" ? "" : "completed-filler"
                }`}
              alt="stepper icon"
              src="../../assets/images/stepperIcon.svg"
            />
          </div>
          <div className="title">
            {patient?.status === "COMPLETED" ? "Checked out" : "Check out"}
          </div>
          {patient?.completedTime && (
            <div className="time">
              {moment(patient?.completedTime, "HH:mm").format("hh:mm A")}
            </div>
          )}
        </div>
      </div>
    )
  }

  const handleSave = () => {
    const temp = { ...patient }
    temp["reason"] = reasons
    setshow(false)
    setDisableButton(false)

    const debouncedButtonClick = debounce(() => {
      onButtonClick({ source: source, patient: temp })
    }, 300);

    debouncedButtonClick();
    handleClose()
  }

  const getTNM = (row: any, index: any) => {
    const keys = Object.keys(row)
    if (keys.length > 0) {
      const stageKey = keys.find((e: any) => e.includes("csStage"))
      return `${row[`${stageKey}`] ? row[`${stageKey}`] : "NA"}`
    } else {
      return "NA"
    }
  }

  const checkAppointmentEditable = (dateToCheck: any) => {
    const twoDaysAgo = subDays(new Date(), 2);
    return isAfter(new Date(dateToCheck), twoDaysAgo);
  };

  function renderActionButtons() {
    return (
      <>
        {userRole !== MocUserRole.NURSE && (
          <div className="icon-buttons d-flex">
            <div>
              {!patient?.arrivalTime &&
                !(
                  patient?.appointmentType === "HC" &&
                  userRole === MocUserRole?.FRONT_DESK
                ) ? (
                <img
                  title={patient?.isEditable ? "No show" : "No show disabled for appointment past 48hrs"}
                  alt="no-show"
                  src="../../assets/images/noShowIcon.svg"
                  className={patient?.isEditable ? "cursor-pointer" : "icon-disabled"}
                  onClick={(e: any) => {
                    if (patient?.isEditable) {
                      setSource("noShow")
                      handleReason(e)
                    }
                  }}
                />
              ) : (
                <></>
              )}
            </div>

            {!patient?.engageTime && (
              <img
                title={patient?.isEditable ? "Reject" : "Reject disabled for appointment past 48hrs"}
                alt="reject"
                src="../../assets/images/rejectIcon.svg"
                className={patient?.isEditable ? "cursor-pointer" : "icon-disabled"}
                onClick={(e: any) => {
                  if (patient?.isEditable) {
                    setSource("reject")
                    handleReason(e)
                  }
                }}
              />
            )}

            {!patient?.engageTime && (
              <img
                title="Reschedule"
                alt="reschedule"
                src="../../assets/images/rescheduleIcon.svg"
                className={(patient?.isEditable && checkAppointmentEditable(patient?.scheduleDate)) ? "cursor-pointer" : "icon-disabled"}
                onClick={() => {
                  if (patient?.isEditable && checkAppointmentEditable(patient?.scheduleDate)) {
                    onButtonClick({ source: "reschedule", patient: patient })
                  }
                }}
              />
            )}
          </div>
        )}

        <div>
          {!show || (source === "noShow" && patient?.arrivalTime !== null) ? (
            <></>
          ) : (
            <>
              <textarea
                value={reasons}
                onChange={(e: any) => {
                  const str = e.target.value

                  let code = str.charCodeAt(str.length - 1)
                  // const char = str[str.length - 1]
                  // let k = char.charCodeAt(0)
                  if (code === 10) {
                    const temp = { ...patient }
                    temp["reason"] = reasons
                    setshow(false)
                    // and CALL UPDATE API
                    onButtonClick({ source: source, patient: temp })
                  }
                  setReason(e.target.value)
                }}
              />
              <div style={{ float: "right" }}>
                <Button text="Save" disabled={disableButton} onClick={() => {
                  setDisableButton(true);
                  handleSave();
                }} />
              </div>
            </>
          )}
        </div>
      </>
    )
  }

  function renderSmartSummarySection() {
    return (
      <div
        className="card-view smart-summary"
        onClick={() =>
          onButtonClick({
            source: "redirectToPatientDiagnosis",
            patient: patient,
          })
        }
      >
        <div
          style={{ marginRight: "50px" }}
          className="icon col-md-1 col-lg-1 p-0"
        >
          <img
            alt="summaryIcon"
            src="../../assets/images/smartSummaryIcon.svg"
          />
        </div>
        <div className="col-md-11 col-lg-11">
          <div className="header">Smart Summary</div>
          <div className="col-md-12 col-lg-12">
            <div className="d-flex">
              <div className="p-0 title pt-2">Diagnosis:</div>&nbsp;&nbsp;
              <div className=" p-0 description pt-2">
                <div className="p-0 description" style={{
                  width: "250px",
                  textOverflow: "ellipsis"
                }}>
                  {smartSummary?.diagnosis?.length > 0 ? (
                    smartSummary?.diagnosis?.map((each: any) => {
                      return (
                        <li>
                          {each?.diagnosis}&nbsp;&nbsp;{each?.cancerType}
                        </li>
                      )
                    })
                  ) : (
                    <div>NA</div>
                  )}
                </div>
              </div>
            </div>
            {/* <div className="d-flex">
              <div className="p-0 title pt-2">Pending Amount:</div>&nbsp;&nbsp;
              <div className=" p-0 description pt-2">
                <div className="p-0 description">
                  {Number(smartSummary?.totalPendingAmount)?.toFixed(2)}
                </div>
              </div>
            </div> */}
            <div className="d-flex p-0">
              <div className="p-0 title mt-2">Last Visit:</div>&nbsp;&nbsp;
              <div className="p-0 description mt-2">
                <div className="p-0 description">
                  {smartSummary?.lastVisit === null
                    ? "NA"
                    : moment(smartSummary?.lastVisit).format(
                      "DD-MM-YYYY, HH:mm "
                    )}
                </div>
              </div>
            </div>

            {/* <div className="col-md-6 col-lg-6 p-0 title mt-2">Last Visit:</div>
            <div className="col-md-2 col-lg-2 p-0 description">
              <span>{moment(smartSummary?.lastVisit).format("LLL")}</span>
            </div> */}
          </div>
          <div className="d-flex">
            <div className="p-0 title pt-2">Stage:</div>&nbsp;&nbsp;
            <div className=" p-0 description pt-2">
              <div className="p-0 description" style={{ textOverflow: "ellipsis", width: "250px" }}>
                {smartSummary?.stage?.length > 0 ? (
                  smartSummary?.stage?.map((each: any, index: any) => {
                    return (
                      <li>
                        {getTNM(each, index)}&nbsp;&nbsp;<span>{each?.cancerType}</span>
                      </li>
                    )
                  })
                ) : (
                  <div>NA</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  }

  function renderCategoryStatement() {
    let statusCheck = AppointmentCalendarUtils.getAppointmentStatus(
      patient?.status
    )
    return `${AppointmentCalendarUtils.getPatientAppointmentType(
      patient?.patientAppointmentType
    )} appointment is ${statusCheck}`
  }

  const handleMaintainPayment = () => {

    handleClose()
    // setIsLoading(true)
    addInvoiceLink(patient?.invoiceId, payment).then((res) => {
      setIsLoading(false)
      setSendPaymentLink({
        type: "success",
        text: `Payment link sent to - ${patient?.primaryPhoneNumber} via sms`,
      })
    })
      .catch((err) => {
        setIsLoading(false)
        console.log(err?.response?.data?.message, "Payment Gatewayyy errrrrorrrrr");
        console.log(err, "Payment Gatewayyy errrrrorrrrr");
        // setSendPaymentLink({
        //   type: "error",
        //   text: err?.response?.data?.message,
        // })

        if (err?.response?.data?.code === 'IMPROPER_PAYMENT_DETAILS') {
          setSendPaymentLink({
            type: "error",
            text: `${err?.response?.data?.message}`
          })
        }
        else {
          setSendPaymentLink({
            type: "error",
            text: `Please specify the amount to send online link to patient`
          })
        }
      })
  }









  function renderPopOver() {
    return (
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        sx={{ width: "100%" }}
      >
        {
          isLoading && (
            <div
              style={{
                position: "fixed",
                top: "80%",
                left: "50%",
                zIndex: 9999,
              }}
            >
              <div
                style={{ width: "3rem", height: "3rem" }}
                className="spinner-border text-primary"
              ></div>
            </div>
          )
        }
        <div className="patient-detail-popover">
          <div className="card-view header-section">
            <div className="name">{patientName}
              {patient?.phoneNumber || patient?.primaryPhoneNumber ? (
                <div className="phone text-truncate">
                  <img
                    className="icon"
                    src={"../../assets/images/phoneIcon.svg"}
                    alt="phoneIcon"
                  />
                  <div className="text">{patient?.phoneNumber || patient?.primaryPhoneNumber}</div>
                </div>
              ) : null}
            </div>
            <div className="patientId">{patient?.mocId}</div>
            <div className="patientId">
              {patient?.gender} {patient?.dob ? calculateAge(patient?.dob) : ""}
            </div>
            {patient?.email ? (
              <div className="email text-truncate">
                <img
                  className="icon"
                  src={"../../assets/images/emailIcon.svg"}
                  alt="emailIcon"
                />
                <div className="text">{patient?.email}</div>
              </div>
            ) : null}

            {/* <!-- Horizontal Stepper Wrapper --> */}
            {(userRole === MocUserRole.FRONT_DESK ||
              userRole === MocUserRole.HOME_CARE_NURSE ||
              userRole === MocUserRole.HOME_CARE_RMO) && patient?.status !== "WAITING_FOR_APPROVAL" &&
              renderHorizontalStepper()}
            {/* <!-- /.Horizontal Stepper Wrapper --> */}

            {patient?.status === "WAITING_FOR_APPROVAL" && <h1 style={{ color: "red", textAlign: "center", marginTop: "2px" }}>The Appointment is not yet Approved</h1>}
          </div>

          {userRole === MocUserRole.NURSE && renderBedDetails()}

          <div className="card-view follow-up">
            <div
              style={{ marginRight: "50px" }}
              className="icon col-md-1 col-lg-1 p-0"
            >
              <img
                className="grey-filler"
                alt="followupIcon"
                src="../../assets/images/opd.svg"
              />
            </div>
            <div>
              <div className="header pt5">
                {AppointmentCalendarUtils.getPatientAppointmentType(
                  patient?.patientAppointmentType
                )}
              </div>
              {userRole === MocUserRole.NURSE ? (
                ""
              ) : (
                <div className="description pt5">
                  with <span className="title">{patient?.consultantName || smartSummary?.primaryConsultantName}</span>
                </div>
              )}

              <div className="description pt5">
                at{" "}
                <span className="title">
                  {slots && slots[0]
                    ? moment(slots[0], "HH:mm").format("hh:mm a")
                    : null}
                </span>
                {(patient?.appointmentType === "OPD" || patient?.appointmentType === "HC") ?
                  <span className="description">
                    {` for `}
                    {slots?.length * centerSlots}
                    {` mins`}
                  </span> : <span className="description">
                    {` for `}
                    {userRole === MocUserRole.NURSE ? NurseSlots?.length * centerBedSlots : patient?.allottedBed?.slots.length * centerBedSlots}
                    {` mins`}
                  </span>
                }
              </div>

              {patient?.appointmentType === "IPD" ? (
                <div className="description pt5">
                  <span className="description">Room:</span>
                  <span className="title ps-1">
                    {patient?.allottedBed?.roomName}
                  </span>
                  <span className="description ps-2">Bed:</span>
                  <span className="title ps-1">
                    {patient?.allottedBed?.bedName}
                  </span>
                </div>
              ) : null}

              <div className="header pt5">
                Category:{" "}
                <span className="description text-capitalize">
                  {renderCategoryStatement()}
                </span>
                <br />
                {patient?.status === "NO_SHOW" && (
                  <div>
                    Reason:
                    <span>{patient?.reason}</span>
                  </div>
                )}
              </div>
              {patient?.bedIsVacant === true ? (
                <div className="header pt5">
                  <span>Bed Vacancy:</span>
                  <span className="description text-capitalize">
                    Bed Is Vacant
                  </span>
                </div>
              ) : (
                ""
              )}

              <div className="d-flex justify-content-space">
                <div className="header pt5">
                  <div>Notes:</div>
                </div>
                <div className="m-2">
                  <span>{patient?.comments}</span>
                </div>
              </div>

              {patient?.status !== "NO_SHOW" &&
                patient?.status !== "CANCELLED" &&
                patient?.status !== "COMPLETED" &&
                renderActionButtons()}
            </div>
          </div>

          {renderSmartSummarySection()}

          {userRole === MocUserRole.FRONT_DESK && (
            <div className="card-view button-section">
              {patient?.appointmentType === "OPD" &&
                !patient?.engageTime &&
                patient?.status !== "NO_SHOW" &&
                patient?.status !== "CANCELLED" &&
                patient?.status !== "COMPLETED" && (
                  <>
                    {
                      !patient?.isConvertedToIpd && (
                        <div className="d-flex p-0 ipd-conversion">
                          <Button
                            text="Convert to IPD"
                            onClick={() =>
                              onButtonClick({
                                source: "convertToIPD",
                                patient: patient,
                              })
                            }
                            id="convert-to-ipd"
                          />
                        </div>
                      )
                    }
                    {/* || patient?.arrivalTime === "Checked in" || patient?.status === "COMPLETED" || patient?.status === "Checked out" || patient?.status === "Check out" || patient?.engageTime === "In Consultation" || patient?.engageTime === "Consultation" */}
                  </>
                )}

              <div>
                {(!(
                  patient?.arrivalTime === "Check in" ||
                  patient?.arrivalTime === "Checked In" ||
                  patient?.engageTime === "In Consultation" ||
                  patient?.engageTime === "Consultation"
                )) || (patient?.status === "Check out" ||
                  patient?.status === "Checked out" ||
                  patient?.status === "COMPLETED" || userRole === MocUserRole.HOME_CARE_RMO || userRole === MocUserRole.HOME_CARE_NURSE) ? (
                  <div className="d-flex mt-8 col-md-12 mt-2">
                    <label className="mt-2" id="enterAmount">Enter The Amount :</label>
                    <InputField
                      handleChange={(e) => {
                        const inputValue = parseInt(e.target.value);
                        if (inputValue > 0 || e.target.value === "") {
                          setIsPayment(inputValue);
                        }
                        else {
                          setIsPayment(0);
                        }
                      }}
                      type="number"
                      value={payment}
                      className="col-md-3"
                    />
                    {showDueDetails === false &&
                      (<div
                        className="col-md-5 text-center link-button"
                        onClick={() => { setShowDueDetails(true); }}
                      >
                        Show Due Details
                      </div>)
                    }
                    &nbsp;&nbsp;

                    {showDueDetails &&
                      (<div className="col-md-4 ml-3">
                        <div className="patient-mocId due-details advance-sd" >Security Deposit : {smartSummary?.securityDeposit.toFixed(2)}</div>
                        <div className="patient-mocId due-details advance-sd">Advance : {smartSummary?.advancePayment.toFixed(2)}</div>
                        <div className="patient-mocId due-details due">Due Amount : {smartSummary?.totalPendingAmount.toFixed(2)}</div>
                      </div>)}
                  </div>
                ) : null}
              </div>

              {patient?.invoiceId && (
                <>
                  <div
                    className="col-md-12 col-lg-12 text-center sms-link"
                    onClick={() => handleMaintainPayment()}
                  >
                    Send the online payment SMS link to patient
                  </div>

                  <div className="col-md-12 col-lg-12 billing">
                    <Button
                      text="Bill / Payment"
                      onClick={() =>
                        onButtonClick({
                          source: "billPayment",
                          patient: patient,
                        })
                      }
                      id="bill-payment"
                    />
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </Popover>
    )
  }

  function renderBedDetails() {
    return (
      <div className="card-view smart-summary">
        <div className="col-md-11 col-lg-11">
          <div className="header">Bed Management</div>
          <span>
            Bed Made VacantAt:&nbsp;
            {patient?.bedMadeVacantAt === null
              ? "-"
              : moment(patient?.bedMadeVacantAt).format("DD-MM-YYYY HH:mm:ss")}
          </span>
          <div className="col-md-12 col-lg-12">
            <div className="col-3"></div>
            {patient?.arrivalTime === null && (
              <div style={{ color: "red" }}>Patient Is Not Yet Checked-In</div>
            )}
            <div className="d-flex justify-space-around">
              <div>
                {bedBook?.bedIsVacant === true ||
                  bedBook?.arrivalTime === null || patient?.bedIsVacant ? (
                  <Button
                    disabled
                    text="Edit"
                    onClick={() =>
                      history.push(
                        `/bedRequests?appointmentId=${patient?.appointmentId}`,
                        patient
                      )
                    }
                  />
                ) : (
                  <Button
                    text="Edit"
                    onClick={() =>
                      history.push(
                        `/bedRequests?appointmentId=${patient?.appointmentId}`,
                        patient
                      )
                    }
                  />
                )}
              </div>
              <div style={{ marginLeft: "20px" }}>
                {bedBook?.bedIsVacant === true ||
                  patient?.arrivalTime === null || patient?.bedIsVacant ? (
                  <Button
                    disabled
                    text="Mark Bed As Vacant"
                    onClick={() => handleBedVacant()}
                  />
                ) : (
                  <Button
                    text="Mark Bed As Vacant"
                    onClick={() => handleBedVacant()}
                  />
                )}
              </div>
              <div style={{ marginLeft: "20px" }}>
                {patient?.arrivalTime !== null && (
                  <Button
                    text="Ready for Discharge"
                    onClick={() => handleReadyForDischarge()}
                  />
                )}
              </div>
              <br />
            </div>
          </div>
        </div>
      </div>
    )
  }

  // {
  //   patient?.status === "CANCELLED" &&
  //     <div>nnnnn</div>
  // }

  function isPatientBday() {
    return (
      patient?.dob &&
      moment(patient?.dob).date() === moment().date() &&
      moment(patient?.dob).month() === moment().month()
    )
  }

  function handleReason(e: any) {
    e.stopPropagation()
    e.preventDefault()
    setReason("")
    setshow(true)
  }

  function enableToast(e: any) {
    e.stopPropagation()
    e.preventDefault()
    setOpen(false)
  }
  function disable(event: any) {
    return !disableClick
      ? !disablePopup
        ? handleClick(event)
        : onButtonClick({
          source: "redirectToPatientDiagnosis",
          patient: patient,
        })
      : null
  }
  return (
    <div className="patient-chip">
      <span
        className="chip-left-border"
        style={{
          backgroundColor: `${hexToRgb(colorCode, 1)}`,
        }}
      />
      <div
        className="chip-content col-lg-10 col-md-10 d-inline-block"
        style={{
          backgroundColor: !outline ? `${hexToRgb(colorCode, 0.75)}` : "white",
          border: !outline ? "" : `1px solid ${hexToRgb(colorCode, 0.75)}`,
          height: `${height * 26}px`, // Use tempheight instead of height
        }}
        onClick={(event) => {
          if (patient?.status === "CANCELLED") {
            setOpen(true);
          } else {
            disable(event);
          }
        }}
      >
        <div className="toastAligner">
          {opens && (
            <Toast
              textMessage={"Appointment is Cancelled"}
              type={"warning"}
              onClose={(e: any) => enableToast(e)}
              onCloseText="Close"
              onClickText={null}
            />
          )}
        </div>
        <div>
          {sendpaymentLink && (
            <Toast
              textMessage={sendpaymentLink?.text}
              onClose={() => {
                setSendPaymentLink(false)
              }}
              onCloseText={"Close"}
              type={sendpaymentLink?.type}
            />
          )}

          {displayToast && (
            <Toast
              textMessage={displayToast?.text}
              type={displayToast?.type}
              onClose={() => {
                toggleDisplayToast(false)
              }}
              onCloseText="Close"
              onClickText={null}
            />
          )}
          {pending && userRole === MocUserRole.FRONT_DESK && <Toast
            textMessage={"Pending Appointment Cannot Be Checked-In"}
            type={"warning"}
            onClose={() => {
              setPending(false)
            }}
            onCloseText="Close"
            onClickText={null}
          />}
        </div>
        <div className="d-flex justify-content-between h-100">
          <div
            className={`text-truncate ${patient?.status === "CANCELLED" ||
              patient?.bedBookingStatus === "CANCELLED"
              ? "strike-through"
              : ""
              }`}
            title={patientName}
          >
            {patientName}
            {description && <div>{description}</div>}
          </div>

          {patient?.patientAppointmentType === "NEW" && (
            <div className="tag">
              <div className="chip-icon">N</div>
            </div>
          )}
          {patient?.status === "WAITING_FOR_APPROVAL" && (
            <div className="tag">
              <div className="chip-icon" >P</div>
            </div>
          )}

          {patient?.status === "NO_SHOW" && (
            <div className="tag">
              <div className="chip-icon">No</div>
            </div>
          )}

          {patient?.isSpecialRequest && (
            <div className="tag">
              <div className="chip-icon">★</div>
            </div>
          )}

          {/* <div className="tag">
            <div className="chip-icon">W</div>
          </div> */}
          {isPatientBday() && (
            <div className="tag">
              <div style={{ paddingRight: "2px" }}>
                <img
                  style={{ width: "14px", height: "14px" }}
                  src={"../../assets/images/birthday_icon.svg"}
                  alt="birthday-icon"
                />
              </div>
            </div>
          )}
        </div>
      </div>

      {renderPopOver()}
    </div>
  )
}
